import { render, staticRenderFns } from "./EllyForm.vue?vue&type=template&id=1ea2f0d6&"
import script from "./EllyForm.vue?vue&type=script&lang=js&"
export * from "./EllyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports